import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { shopifyIntegrationQuery } from "modules/settings/lib/shopify/shopifyIntegrationQuery"
import { useTranslation } from "react-i18next"
import { DataResponse, ShopifyIntegrationResponseDataSchema } from "schema"
import { toast } from "sonner"
import { z } from "zod"

type Response = DataResponse<
  Pick<z.infer<typeof ShopifyIntegrationResponseDataSchema>, "activeWidgetCampaignId">
>

export function useShopifyCampaignWidgetMutation() {
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async ({ campaignId }: { campaignId: string }) => {
      const response = await axios.post<Response>("/integrations/shopify/widget", { campaignId })

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: shopifyIntegrationQuery().queryKey })
      toast.success(t("campaigns.trigger.metadata.widget.shopifyInstall.success"))
    },
  })
}
